module.exports = __webpack_public_path__ + "static/img/logo.82b9c7a.png";


//////////////////
// WEBPACK FOOTER
// ./vue-django/src/assets/logo.png
// module id = uxgT
// module chunks = 110